var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"page","mode":"out-in"}},[(_vm.loading)?_c('div',{staticClass:"cover"},[_c('div',{attrs:{"id":"ballWrapper"}},[_c('div',{staticClass:"loading-ball",attrs:{"id":"ball"}},[_c('span',{staticClass:"loader"})])])]):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7440163b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/spinner/Spinner.vue
// module id = QUu1
// module chunks = 57